import { render } from "./repairForm.vue?vue&type=template&id=2dc8f839"
import script from "./repairForm.vue?vue&type=script&lang=js"
export * from "./repairForm.vue?vue&type=script&lang=js"

import "./repairForm.vue?vue&type=style&index=0&id=2dc8f839&lang=less"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__